import React from 'react' 

export default class Textarea extends React.Component {
	componentDidUpdate(prevProps) {
		if (!prevProps.meta.active && this.props.active) {
			this.input.focus()
		}
	}

	render() {
		let error;
        if (this.props.meta.touched && this.props.meta.error) {
            error = <div className="form-error">{this.props.meta.error}</div>;
        }

        let warning;
        if (this.props.meta.touched && this.props.meta.warning) {
            warning = (
                <div className="form-warning">{this.props.meta.warning}</div>
            );
        }

        return (
        	<div className="form-textarea">
        		<label htmlFor={this.props.input.name}>
        			{this.props.label}
        		</label>
        		<textarea
        			{...this.props.input}
                    className='bio col-12'
        			id={this.props.input.name}
        			type={this.props.type}
        			ref={input => (this.input = input)}
        		/>
        		{error}
        		{warning}
        	</div>
        )
	}
}


// WEBPACK FOOTER //
// ./src/components/textarea.js